export const FORM_TITLE_LINES = ['Sign in'];
